import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IStoreSlice } from "@/redux/slices/store/types";

export const getPlanPrices = createAsyncThunk(
  "store/getPlanPrices",
  async () =>
    await axios({
      method: "GET",
      url: `/svc/store-pricing/`,
    }).then((res) => ({
      plans: res.data?.result || [],
      number_costs: res.data?.number_costs || {},
    }))
);

const pending = (state: IStoreSlice) => {
  state.plan_prices = {
    loaded: false,
    plans: [],
    number_costs: {},
  };
};

const fulfilled = (
  state: IStoreSlice,
  { payload }: { payload: IStoreSlice["plan_prices"] },
) => {
  state.plan_prices.plans = payload.plans;
  state.plan_prices.number_costs = payload.number_costs;
  state.plan_prices.loaded = true;
};

export default {
  action: getPlanPrices,
  pending,
  fulfilled,
};
